import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const WHATSAPP_NUMBER = "233506424358";
export const WHATSAPP_LINK = `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(
  "Hello R.O.K Motors, I'd like to enquire about shipping from the USA to Ghana."
)}`;
export const PHONE_DISPLAY = "0506424358";
export const EMAIL = "info@rokmotors.com";

// Normalise a Ghana number to international digits (e.g. "0506424358" -> "233506424358")
export const intlDigits = (num) => {
  const d = String(num || "").replace(/\D/g, "");
  if (d.startsWith("233")) return d;
  if (d.startsWith("0")) return "233" + d.slice(1);
  return d;
};

export const waLink = (num) =>
  `https://wa.me/${intlDigits(num)}?text=${encodeURIComponent(
    "Hello R.O.K Motors, I'd like to enquire about shipping from the USA to Ghana."
  )}`;

export const telLink = (num) => `tel:+${intlDigits(num)}`;

const api = axios.create({ baseURL: API, withCredentials: true });

export function formatApiErrorDetail(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export default api;
